import { render } from "./App.vue?vue&type=template&id=57e27c10"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=57e27c10&lang=css"

import exportComponent from "/Users/jb 1/Repositories/Memify/frontend/slide-stories/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__